import React from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";

import './DTEStatusMui.css'
export default function DTEStatusMui(props) {
  const { closeModal, dteStatus, number, documentType, message, description } = props;

  let statusAsString = '';
  let color = 'Black';
  switch(dteStatus) {
      case 'SentToSii': 
      statusAsString = 'Enviado al Sii'; 
      break;
      case 'ApprovedWithWarningsBySii': statusAsString = message; color = 'Orange'; break;
      case 'ApprovedBySii': statusAsString = message; color = 'Green'; break;
      case 'RejectedBySii': statusAsString = message; color = 'Red'; break;
      default: statusAsString = message; break; 
  }

  const handleCloseModal = () => {
    closeModal();
  };

  return (
    <div class="dte-status-mui-body">
     <div>Estado DTE: <strong style={{ color: color }}>{statusAsString}</strong></div>
     <div>Número Folio: <strong>{number}</strong></div>
     <div>Tipo Folio: <strong>{documentType}</strong></div>
     { description && <div>Observaciones: <strong>{ description }</strong></div>}
     <Box style={{ float: "right" }}>
        {" "}    
        <Button onClick={handleCloseModal} color="primary">
              {
                "Aceptar"
              }        
            </Button>
            
      </Box>
    </div>
  );
}
